<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre5">
<span href="#/Text/Section0028" id="id-5082595189328765907" title="Link target outside of Sample">
<img alt="Yours truly James Greenwood (picture of Greenwood)" class="calibre6" id="id-379742613087317795" src="Images/img0002.jpg" title="Yours truly James Greenwood (picture of Greenwood)"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?11dd1c5d